/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlNotifyZeroDayAlertClientsRequest
 */
export interface ControlNotifyZeroDayAlertClientsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlNotifyZeroDayAlertClientsRequest
     */
    client_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlNotifyZeroDayAlertClientsRequest interface.
 */
export function instanceOfControlNotifyZeroDayAlertClientsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_ids" in value;

    return isInstance;
}

export function ControlNotifyZeroDayAlertClientsRequestFromJSON(json: any): ControlNotifyZeroDayAlertClientsRequest {
    return ControlNotifyZeroDayAlertClientsRequestFromJSONTyped(json, false);
}

export function ControlNotifyZeroDayAlertClientsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlNotifyZeroDayAlertClientsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_ids': json['client_ids'],
    };
}

export function ControlNotifyZeroDayAlertClientsRequestToJSON(value?: ControlNotifyZeroDayAlertClientsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_ids': value.client_ids,
    };
}

